import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';

// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import RadioQuestionPreview from '../../AdminPoll/QuestionPreviews/RadioQuestionPreview';
import AnswerQuestionPreview from '../../AdminPoll/QuestionPreviews/AnswerQuestionPreview';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import OfferedMultipleAnswerQuestionPreview from '../../AdminPoll/QuestionPreviews/OfferedMultipleAnswerQuestionPreview';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import SliderQuestionPreview from '../../AdminPoll/QuestionPreviews/SliderQuestionPreview';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import OfferedAnswerQuestionPreview from '../../AdminPoll/QuestionPreviews/OfferedAnswerQuestionPreview';
import DateQuestionPreview from '../../AdminPoll/QuestionPreviews/DateQuestionPreview';
import OfferedMultipleAnswerQuestionCommentPreview
    from '../../AdminPoll/QuestionPreviews/OfferedMultipleAnswerQuestionCommentPreview';
import OfferedAnswerQuestionCommentPreview from '../../AdminPoll/QuestionPreviews/OfferedAnswerQuestionCommentPreview';


export default class StudentPollPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            pollQuestion: [],
            sections: [],
            allAnswers: [],


        };
        this.child = React.createRef();
        this.getPollQuestionsById = this.getPollQuestionsById.bind(this);
        this.fetchQuestionSections = this.fetchQuestionSections.bind(this);
        this.deleteLastQuestionById = this.deleteLastQuestionById.bind(this);
        this.submitAllAnswers = this.submitAllAnswers.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.checkRequiredFields = this.checkRequiredFields.bind(this);
        this.getQuestionsWithoutOptions = this.getQuestionsWithoutOptions.bind(this);
        this.isOfferedAnswerQuestion = this.isOfferedAnswerQuestion.bind(this);
        this.updateQuestionComment = this.updateQuestionComment.bind(this);
        this.connectStudent = this.connectStudent.bind(this);
    }
    connectStudent() {
        let obj = {};
        let poll = JSON.parse(localStorage.getItem('poll'));
        axios.post(`/questionnaire/connect-student/${poll.pollId}/`, { ...obj })
            .then(res => {
                this.submitAllAnswers();
            })
            .catch(err => {
                if (err.response.data === 'ba.utic.isss.common.exceptions.IsssException: Student is already connected with this questionnaireLink!') {
                    this.submitAllAnswers();
                } else if (err.response.data === 'ba.utic.isss.common.exceptions.IsssException: Student can\'t fill this questionnaire!') {
                    toast(<FormattedMessage id="poll.alreadyAnswered" />);
                } else {
                    toast(<FormattedMessage id="poll.connectStudentToDirectionError" />);
                    console.log('Failed to connect student to courseImplementationPoll.');
                }
            });
    }


    validateInput() {
        this.child.current.validateInput();
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.fetchQuestionSections(JSON.parse(localStorage.getItem('poll')).pollType);
        this.getPollQuestionsById(JSON.parse(localStorage.getItem('poll')).pollId);
    }

    fetchQuestionSections(pollTypeId) {
        axios.get(`/questionnaire/get-sections/${pollTypeId}/`)
            .then(res => {
                const sections = res.data.map(el => ({
                    value: el.id,
                    key: el._key,
                    orderNumber: parseInt(el.orderNumber, 10),
                    text: el.displayName
                }));
                this.setState({ sections: sections.sort((a, b) => a.orderNumber - b.orderNumber) }, () => console.log('sekcije: ', this.state.sections));
            }).catch(err => {
                console.log('Failed to fetch question sections.');
            });
    }

    getPollQuestionsById(id) {
        axios.get(`/questionnaire/all/questions/${id}/`)
            .then(res => {
                const pollQuestions = res.data;
                this.setState({
                    pollQuestions,
                    loader: false,
                    showSendButton: true
                });
            }).catch(err => {
                this.setState({ loader: false });
                toast(<FormattedMessage id="poll.errorFetchingQuestions" />);
                console.log('Failed to fetch question.');
            });
    }
    updateQuestionComment(questionId, staffId, comment) {
        let newAllAnswers = [];
        this.state.allAnswers.map((e) => {
            if (staffId === (e.courseImplementationStaff ? e.courseImplementationStaff.id : undefined) && questionId === e.question.id) {
                let newE = {

                    questionTypeName: e.questionTypeName,
                    floatAnswer: e.floatAnswer,
                    textAnswer: comment,
                    cannotRate: e.cannotRate,
                    courseImplementationStaff: e.courseImplementationStaff,
                    question: e.question,
                    questionOptions: e.questionOptions

                };
                return newAllAnswers.push(newE);
            }newAllAnswers.push(e);

            this.setState({ allAnswers: newAllAnswers });
        });
    }

    deleteLastQuestionById(id, answer, staffId) {
        let newAllAnswers = this.state.allAnswers.filter(e => {
            if ((staffId === (e.courseImplementationStaff ? e.courseImplementationStaff.id : undefined)) && id === e.question.id) {
                return false;
            }
            return e;
        });
        newAllAnswers.push(answer);
        console.log('novi svi odg: ', newAllAnswers);
        this.setState({ allAnswers: newAllAnswers });
    }
    checkRequiredFields() {
        let temp = false;
        temp = this.state.allAnswers.find((e) => ((e.textAnswer === null || e.textAnswer === undefined || e.textAnswer === '') && e.floatAnswer === null && e.questionOptions.length === 0) || (e.questionOptions.length === 0 && e.questionTypeName === 'više odgovora sa komentarom'));
        return temp;
    }
    isOfferedAnswerQuestion(questionTypeName) {
        return [
            'jedan odgovor',
            'jedan odgovor sa komentarom',
            'viÅ¡e odgovora',
            'viÅ¡e odgovora sa komentarom',
            'više odgovora',
            'više odgovora sa komentarom'
        ].includes(questionTypeName);
    }
    getQuestionsWithoutOptions() {
        return (this.state.pollQuestions || []).filter(e =>
            e.question &&
            e.question.questionType &&
            this.isOfferedAnswerQuestion(e.question.questionType.name) &&
            (!e.questionOptions || e.questionOptions.length === 0));
    }
    submitAllAnswers() {
        let selectedProfessors = JSON.parse(localStorage.getItem('selectedProfessors'));
        let selectedAssistants = JSON.parse(localStorage.getItem('selectedAssistants')) ? JSON.parse(localStorage.getItem('selectedAssistants')) : [];
        let numOfAssiQuestions = this.state.pollQuestions.filter(e => e.question.section._key === 'assistant').length;
        let numOfProfQuestions = this.state.pollQuestions.filter(e => e.question.section._key === 'professor').length;
        let isStudyProgramEvaluation = localStorage.getItem('studyProgramEvaluation') === 'true';

        let br = isStudyProgramEvaluation ? this.state.pollQuestions.length : selectedProfessors.length * numOfProfQuestions + (this.state.pollQuestions.length - numOfAssiQuestions - numOfProfQuestions) + selectedAssistants.length * numOfAssiQuestions;

        // eslint-disable-next-line prefer-destructuring
        let pollId = JSON.parse(localStorage.getItem('poll')).pollId;
        let courseId = localStorage.getItem('courseId');
        let obj = {
            studentAnswerDTOS: this.state.allAnswers,
            courseImplementation: courseId ? { id: courseId } : null
        };
        const questionsWithoutOptions = this.getQuestionsWithoutOptions();

        if (questionsWithoutOptions.length > 0) {
            toast(<FormattedMessage id="poll.questionWithoutOptions" values={{ text: questionsWithoutOptions[0].question.text }} />);
            return;
        }

        if (this.state.allAnswers.length === br && !this.checkRequiredFields()) {
            this.setState({ disableSubmitButton: true });

            axios.post(`questionnaire/answer/${pollId}/`, obj)
                .then(res => {
                    // izbrisat ponesto i local
                    toast(<FormattedMessage id="poll.answersSentSuccess" />);
                    this.setState({ redirect: true });
                })
                .catch(err => {
                    this.setState({ showPollPreview: true, showPollForm: false, disableSubmitButton: false });
                    toast(<FormattedMessage id="poll.errorSendingAnswers" />);
                    console.log('Failed to submit poll answers.');
                });
        } else { toast(<FormattedMessage id="poll.notAllAnswered" />); }
    }

    render() {
        let {
            pollQuestions, sections
        } = this.state;
        if (this.state.redirect) return localStorage.getItem('academicStaffEvaluation') ? <Redirect push to={{ pathname: '/anketa/predmeti/' }} /> : <Redirect push to={{ pathname: '/ankete' }} />;

        const pollComment = JSON.parse(localStorage.getItem('poll')).pollComment;
        return (

            <div>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h2">
                            {JSON.parse(localStorage.getItem('poll')).pollName}
                        </Header>
                    </Segment>
                    {pollComment &&
                        <Segment style={{ textAlign: 'justify' }}>
                            {JSON.parse(localStorage.getItem('poll')).pollComment}
                        </Segment>
                    }
                </Segment.Group>
                {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader size="medium" inline="centered" active /></div> :

                    pollQuestions ?
                        sections.map(section =>

                            (<SectionPreview
                                ref={this.child}
                                update={this.getPollQuestionsById}
                                deleteLastQuestionById={this.deleteLastQuestionById}
                                updateQuestionComment={this.updateQuestionComment}
                                sectionDisplayName={section.text}
                                sectionKey={section.key}
                                sectionQuestionList={pollQuestions.filter(question => section.key === question.question.section._key)}
                            />))
                        : <FormattedMessage id="poll.noQuestionsInPoll" />}


                {this.state.showSendButton && <Link to={{
                    pathname: '/ankete'

                }}
                >
                    <Button
                        // vratiti ga na listu predmeta
                        floated="right"
                        color="blue"
                        basic
                        onClick={() => {
                            localStorage.removeItem('courseId');
                            localStorage.removeItem('courseName');
                            localStorage.removeItem('professors');
                            localStorage.removeItem('assistants');
                        }}
                    >
                                <FormattedMessage id="poll.cancel" />
                    </Button>
                </Link>}

                {this.state.showSendButton &&
                <Button
                    disabled={this.state.disableSubmitButton}
                    onClick={localStorage.getItem('studyProgramEvaluation') === 'true' ? this.connectStudent : this.submitAllAnswers}
                    floated="right"
                    color="blue"
                    primary
                >
                            <FormattedMessage id="poll.sendAnswersButton" />
                </Button>
                }
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

StudentPollPreview.propTypes = {


};

class SectionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.child = React.createRef();
        this.submitRadioQuestion = this.submitRadioQuestion.bind(this);
        this.submitAnswersQuestion = this.submitAnswersQuestion.bind(this);
        this.submitDateQuestion = this.submitDateQuestion.bind(this);
        this.submitOfferedAnswerCommentQuestion = this.submitOfferedAnswerCommentQuestion.bind(this);
        this.submitOfferedAnswerQuestion = this.submitOfferedAnswerQuestion.bind(this);
        this.submitOfferedMultipleAnswerQuestion = this.submitOfferedMultipleAnswerQuestion.bind(this);
        this.submitOfferedMultipleAnswerCommentQuestion = this.submitOfferedMultipleAnswerCommentQuestion.bind(this);
        this.submitSliderQuestion = this.submitSliderQuestion.bind(this);
    }
    componentDidMount() {

    }

    submitAnswersQuestion(questionId, answerText, staffId, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: answerText,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: []
        };
        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }

    submitDateQuestion(questionId, answerDate, staffId, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: answerDate ? answerDate.toISOString() : null,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: []

        };

        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }
    submitOfferedAnswerCommentQuestion(questionId, selectedAnswerId, staffId, typeName, comment) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: comment,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: [{ id: selectedAnswerId }]

        };
        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }

    submitOfferedAnswerQuestion(questionId, selectedAnswerId, staffId, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: null,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: [{ id: selectedAnswerId }]

        };

        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }

    submitOfferedMultipleAnswerQuestion(questionId, selectedAnswerIds, staffId, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: null,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: selectedAnswerIds.map((e) => ({ id: e }))

        };

        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }
    submitOfferedMultipleAnswerCommentQuestion(questionId, selectedAnswerIds, staffId, typeName, comment) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: null,
            textAnswer: comment,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: selectedAnswerIds.map((e) => ({ id: e }))

        };

        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }


    submitRadioQuestion(questionId, answerValue, staffId, np, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: answerValue,
            textAnswer: null,
            cannotRate: np,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: []

        };
        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }

    submitSliderQuestion(questionId, answerValue, staffId, typeName) {
        let answer = {
            questionTypeName: typeName,
            floatAnswer: answerValue,
            textAnswer: null,
            cannotRate: false,
            courseImplementationStaff: staffId ? { id: staffId } : null,
            question: { id: questionId },
            questionOptions: []
        };
        this.props.deleteLastQuestionById(questionId, answer, staffId);
    }
    validateInput() {
        this.child.current.validateInput();
    }


    render() {
        let { sectionDisplayName, sectionQuestionList, sectionKey } = this.props;
        let selectedProfessors = JSON.parse(localStorage.getItem('selectedProfessors'));
        let selectedAssistants = JSON.parse(localStorage.getItem('selectedAssistants')) ? JSON.parse(localStorage.getItem('selectedAssistants')) : [];

        let professors = JSON.parse(localStorage.getItem('professors'));
        let assistants = JSON.parse(localStorage.getItem('assistants'));
        let courseName = localStorage.getItem('courseName');// ako je akademsko
        return (


            <Fragment>

                {sectionQuestionList.length === 0 ? <Fragment /> :
                    sectionKey === 'professor' || sectionKey === 'assistant' ?
                        ((sectionKey === 'assistant' && selectedAssistants.length === 0) || (sectionKey === 'professor' && selectedProfessors.length === 0)) ? <Fragment /> : <Segment.Group raised>
                            {(sectionKey === 'professor' ? (selectedProfessors) : (selectedAssistants)).map((staffId) => (

                                <Fragment >
                                    <Segment> <Header
                                        as="h3"
                                    >
                                        {sectionDisplayName}:&nbsp;
                                        {(sectionKey === 'professor' ? (professors) : (assistants)).map((el) => { if (el.value === staffId) return (el.text); })}
                                        {/*    <hr /> <p style={{ fontSize: '12px', fontWeight: 'bold' }}>*UPUTA: Odgovore vrednujete sa */}
                                        {/* ponuđenom skalom ocjena od 1 do 5, gdje [1] predstavlja najnižu ocjenu (potpuno */}
                                        {/* nezadovoljna/nezadovoljan), a [5] najvišu (potpuno zadovoljna/zadovoljan). Ukoliko */}
                                        {/* procjenite da na određena pitanja ne možete dati adekvatan objektivan odgovor, molimo Vas */}
                                        {/* da označite odgovor 'Ne mogu procijeniti'. */}
                                        {/* Kada jednom ocijenite predmet, više nećete imati pristup istom.</p> */}
                                    </Header>
                                    </Segment>
                                    <Segment>
                                        {sectionQuestionList.length !== 0 ? sectionQuestionList.map((e, index) => {
                                            if (e.question.questionType.name === 'select') {
                                                return <Segment > <RadioQuestionPreview ref={this.child} key={index} staff={staffId} submitRadioQuestion={this.submitRadioQuestion} text={e.question.text} np={e.question.cannotRate} from={e.question.scaleFrom} to={e.question.scaleTo} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} />  </Segment>;
                                            }
                                            if (e.question.questionType.name === 'tekst') {
                                                return <Segment ><AnswerQuestionPreview ref={this.child} staff={staffId} submitAnswersQuestion={this.submitAnswersQuestion} text={e.question.text} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'više odgovora') {
                                                return <Segment ><OfferedMultipleAnswerQuestionPreview ref={this.child} staff={staffId} submitOfferedMultipleAnswerQuestion={this.submitOfferedMultipleAnswerQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'više odgovora sa komentarom') {
                                                return <Segment ><OfferedMultipleAnswerQuestionCommentPreview ref={this.child} staff={staffId} updateQuestionComment={this.props.updateQuestionComment} submitOfferedMultipleAnswerCommentQuestion={this.submitOfferedMultipleAnswerCommentQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'slajder') {
                                                return <Segment > <SliderQuestionPreview ref={this.child} staff={staffId} submitSliderQuestion={this.submitSliderQuestion} text={e.question.text} from={e.question.scaleFrom} to={e.question.scaleTo} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }

                                            if (e.question.questionType.name === 'jedan odgovor') {
                                                return <Segment > <OfferedAnswerQuestionPreview ref={this.child} staff={staffId} submitOfferedAnswerQuestion={this.submitOfferedAnswerQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'jedan odgovor sa komentarom') {
                                                return <Segment > <OfferedAnswerQuestionCommentPreview ref={this.child} staff={staffId} updateQuestionComment={this.props.updateQuestionComment} submitOfferedAnswerCommentQuestion={this.submitOfferedAnswerCommentQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'datum') {
                                                return <Segment ><DateQuestionPreview ref={this.child} staff={staffId} submitDateQuestion={this.submitDateQuestion} text={e.question.text} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                        }) : <FormattedMessage id="poll.noQuestions" />}

                                    </Segment>
                                </Fragment>
                            ))

                            }
                        </Segment.Group>
                        :
                        <Fragment>
                            <Segment.Group raised>
                                <Segment> <Header as="h3">{sectionDisplayName}:&nbsp;{sectionKey === 'course' ? courseName : ''}</Header></Segment>
                                <Segment>
                                    <div>
                                        {sectionQuestionList.length !== 0 ? sectionQuestionList.map((e) => {
                                            if (e.question.questionType.name === 'select') {
                                                return <Segment > <RadioQuestionPreview ref={this.child} submitRadioQuestion={this.submitRadioQuestion} text={e.question.text} np={e.question.cannotRate} from={e.question.scaleFrom} to={e.question.scaleTo} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} />  </Segment>;
                                            }
                                            if (e.question.questionType.name === 'tekst') {
                                                return <Segment ><AnswerQuestionPreview ref={this.child} submitAnswersQuestion={this.submitAnswersQuestion} text={e.question.text} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'više odgovora') {
                                                return <Segment ><OfferedMultipleAnswerQuestionPreview ref={this.child} submitOfferedMultipleAnswerQuestion={this.submitOfferedMultipleAnswerQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'više odgovora sa komentarom') {
                                                return <Segment ><OfferedMultipleAnswerQuestionCommentPreview ref={this.child} updateQuestionComment={this.props.updateQuestionComment} submitOfferedMultipleAnswerCommentQuestion={this.submitOfferedMultipleAnswerCommentQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }

                                            if (e.question.questionType.name === 'slajder') {
                                                return <Segment > <SliderQuestionPreview ref={this.child} submitSliderQuestion={this.submitSliderQuestion} text={e.question.text} from={e.question.scaleFrom} to={e.question.scaleTo} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }

                                            if (e.question.questionType.name === 'jedan odgovor') {
                                                return <Segment > <OfferedAnswerQuestionPreview ref={this.child} submitOfferedAnswerQuestion={this.submitOfferedAnswerQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'jedan odgovor sa komentarom') {
                                                return <Segment > <OfferedAnswerQuestionCommentPreview ref={this.child} updateQuestionComment={this.props.updateQuestionComment} submitOfferedAnswerCommentQuestion={this.submitOfferedAnswerCommentQuestion} text={e.question.text} answerOptions={e.questionOptions} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                            if (e.question.questionType.name === 'datum') {
                                                return <Segment ><DateQuestionPreview ref={this.child} submitDateQuestion={this.submitDateQuestion} text={e.question.text} typeName={e.question.questionType.name} typeId={e.question.questionType.id} questionId={e.question.id} /></Segment>;
                                            }
                                        }) : <FormattedMessage id="poll.noQuestions" />}

                                    </div>
                                </Segment>
                            </Segment.Group>


                        </Fragment>}

            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/StudentPoll/PollPreview/StudentPollPreview.js